import React from 'react';
import {
  Box,
  Heading,
  Text,
  VStack,
  Container,
  Image,
  Flex,
  SimpleGrid,
  Icon,
  useColorModeValue
} from '@chakra-ui/react';
import { FaLightbulb, FaRocket, FaHandsHelping } from 'react-icons/fa';

const VisionPage = () => {
  const primaryColor = '#F2C919';
  const secondaryColor = '#2C3E50';
  const bgColor = useColorModeValue('gray.50', 'gray.900');
  const cardBg = useColorModeValue('white', 'gray.800');
  const textColor = useColorModeValue('gray.700', 'gray.200');

  return (
    <Box minH="100vh" bg={bgColor} py={10} dir="rtl">
      <Container maxW="container.xl">
        <VStack spacing={8} align="center" textAlign="center" mb={12}>
          <Heading as="h1" size="2xl" color={secondaryColor} fontWeight="bold">
            رؤيتنا
          </Heading>
          <Text fontSize="xl" color="gray.600" maxW="3xl">
            في منصة كوبرا التعليمية، نؤمن بأن التعليم هو مفتاح المستقبل. رؤيتنا هي تمكين الطلاب والمعلمين على حد سواء من خلال توفير بيئة تعليمية مبتكرة وشاملة.
          </Text>
        </VStack>

        <Flex
          direction={{ base: 'column', md: 'row' }}
          align="center"
          justify="space-around"
          mb={12}
          p={6}
          bg={cardBg}
          borderRadius="xl"
          boxShadow="lg"
        >
          <Box flex="1" textAlign={{ base: 'center', md: 'right' }} mb={{ base: 8, md: 0 }} ml={{ base: 0, md: 10 }}>
            <Heading as="h2" size="xl" mb={4} color={secondaryColor}>
              لماذا نحن هنا؟
            </Heading>
            <Text fontSize="lg" color={textColor}>
              نسعى لسد الفجوة التعليمية وتوفير موارد عالية الجودة لكل طالب، بغض النظر عن موقعه أو ظروفه. نهدف إلى بناء جيل متعلم ومبتكر قادر على مواجهة تحديات المستقبل.
            </Text>
          </Box>
          <Box flex="1" display="flex" justifyContent="center" alignItems="center">
            <Image 
              src="/assets/vision-image.jpg" 
              alt="Our Vision" 
              boxSize={{ base: '250px', md: '350px' }} 
              objectFit="cover" 
              borderRadius="lg"
              boxShadow="xl"
            />
          </Box>
        </Flex>

        <VStack spacing={8} align="center" textAlign="center" mb={12}>
          <Heading as="h2" size="xl" color={secondaryColor} fontWeight="bold">
            قيمنا الأساسية
          </Heading>
          <SimpleGrid columns={{ base: 1, md: 3 }} spacing={10} w="full">
            <VStack p={6} bg={cardBg} borderRadius="lg" boxShadow="md" spacing={4}>
              <Icon as={FaLightbulb} boxSize={12} color={primaryColor} />
              <Heading as="h3" size="md" color={secondaryColor}>الابتكار</Heading>
              <Text color={textColor}>نلتزم بتقديم أحدث التقنيات وأساليب التدريس لضمان تجربة تعليمية متطورة.</Text>
            </VStack>
            <VStack p={6} bg={cardBg} borderRadius="lg" boxShadow="md" spacing={4}>
              <Icon as={FaHandsHelping} boxSize={12} color={primaryColor} />
              <Heading as="h3" size="md" color={secondaryColor}>الشمولية</Heading>
              <Text color={textColor}>نسعى لجعل التعليم متاحًا للجميع، مع مراعاة الاحتياجات المتنوعة لطلابنا.</Text>
            </VStack>
            <VStack p={6} bg={cardBg} borderRadius="lg" boxShadow="md" spacing={4}>
              <Icon as={FaRocket} boxSize={12} color={primaryColor} />
              <Heading as="h3" size="md" color={secondaryColor}>التميز</Heading>
              <Text color={textColor}>نطمح دائمًا لتحقيق أعلى معايير الجودة في المحتوى والخدمات التي نقدمها.</Text>
            </VStack>
          </SimpleGrid>
        </VStack>

        <VStack spacing={8} align="center" textAlign="center">
          <Heading as="h2" size="xl" color={secondaryColor} fontWeight="bold">
            مستقبلنا
          </Heading>
          <Text fontSize="lg" color="gray.600" maxW="3xl">
            نتطلع إلى التوسع وتقديم المزيد من الدورات والموارد، وبناء مجتمع تعليمي مزدهر يدعم النمو المستمر والتعلم مدى الحياة.
          </Text>
        </VStack>
      </Container>
    </Box>
  );
};

export default VisionPage;


